// Guest to episode date mapping (latest first)
// Extracted from Lenny's Podcast episodes page: https://www.lennyslightninground.com/episodes/
// Format: YYYY-MM-DD for easy sorting
export const guestEpisodeDates: Record<string, string> = {
  // 2026 Episodes
  'Sam Lessin': '2026-01-15',
  'Aishwarya Naresh Reganti': '2026-01-11',
  'Kiriti Badam': '2026-01-11',
  'Molly Graham': '2026-01-04',
  'Jason Lemkin': '2026-01-01',
  
  // 2025 Episodes (Dec - Nov)
  'Matt MacInnis': '2025-12-28',
  'Sander Schulhoff': '2025-12-21',
  'Elena Verna': '2025-12-18',
  'Alexander Embiricos': '2025-12-14',
  'Edwin Chen': '2025-12-07',
  'Tomer Cohen': '2025-12-04',
  'Jeanne Grosser': '2025-11-30',
  'Rachel Lockett': '2025-11-23',
  'Stewart Butterfield': '2025-11-20',
  'Dr. Fei Fei Li': '2025-11-16',
  'Grant Lee': '2025-11-13',
  'Jen Abel': '2025-11-09',
  'Melanie Perkins': '2025-11-02',
  'Dhanji R. Prasanna': '2025-10-26',
  'Chip Huyen': '2025-10-23',
  'Nicole Forsgren': '2025-10-19',
  'Dylan Field': '2025-10-16',
  'Robby Stein': '2025-10-10',
  'Jason Droege': '2025-10-09',
  'Albert Cheng': '2025-10-05',
  'Nesrine Changuel': '2025-09-28',
  'Hamel Husain': '2025-09-25',
  'Shreya Shankar': '2025-09-25',
  'Julie Zhuo': '2025-09-21',
  'Brendan Foody': '2025-09-18',
  'Ethan Smith': '2025-09-14',
  'Ben Horowitz': '2025-09-11',
  'Oji Udezue': '2025-09-07',
  'Ezinne Udezue': '2025-09-07',
  'Howie Liu': '2025-08-31',
  'Asha Sharma': '2025-08-28',
  'Garrett Lord': '2025-08-24',
  'Eoghan McCabe': '2025-08-21',
  'Brian Balfour': '2025-08-17',
  'Matt LeMay': '2025-08-14',
  'Nick Turley': '2025-08-09',
  'Chip Conley': '2025-08-03',
  'Bret Taylor': '2025-07-31',
  'Madhavan Ramanujam': '2025-07-27',
  'Ben Mann': '2025-07-20',
  'Dan Shipper': '2025-07-17',
  'Jake Knapp': '2025-07-13',
  'John Zeratsky': '2025-07-13',
  'Maor Shlomo': '2025-07-06',
  'Andrew Wilkinson': '2025-07-03',
  'David Placek': '2025-06-29',
  'Peter Deng': '2025-06-22',
  'Hilary Gridley': '2025-06-15',
  'Bob Baxley': '2025-06-12',
  'Sebastian Barrios': '2025-06-08',
  'Mike Krieger': '2025-06-05',
  'Sachin Kansal': '2025-06-01',
  'Krithika Shankarraman': '2025-05-25',
  'Mayur Kamat': '2025-05-22',
  'Aparna Chennapragada': '2025-05-18',
  'Dmitry Zlokazov': '2025-05-15',
  'Nabeel S. Qureshi': '2025-05-11',
  'Jerry Colonna': '2025-05-08',
  'Scott Wu': '2025-05-04',
  'Michael Truell': '2025-05-01',
  'Daniel Lereya': '2025-04-27',
  'Varun Mohan': '2025-04-20',
  'Guillermo Rauch': '2025-04-13',
  'Kevin Weil': '2025-04-10',
  'Wes Kao': '2025-04-06',
  'Ryan Singer': '2025-03-30',
  'Gaurav Misra': '2025-03-27',
  'Rahul Vohra': '2025-03-23',
  'Susan Cain': '2025-03-16',
  'Eric Simons': '2025-03-13',
  'Anton Osika': '2025-03-09',
  'Ivan Zhao': '2025-03-06',
  'Matt Mullenweg': '2025-03-02',
  'Keith Coleman': '2025-02-27',
  'Jay Baxter': '2025-02-27',
  'Bob Moesta': '2025-02-23',
  'Uri Levine': '2025-02-16',
  'Karina Nguyen': '2025-02-09',
  'Tobi Lütke': '2025-02-02',
  'Nan Yu': '2025-01-30',
  'Chandra Janakiraman': '2025-01-26',
  'Graham Weaver': '2025-01-16',
  'Rohini Pandhi': '2025-01-12',
  'Drew Houston': '2025-01-09',
  'Alisa Cohn': '2025-01-06',
  'Eilon Reshef': '2025-01-02',
  
  // 2024 Episodes
  'Shaun Clowes': '2024-12-29',
  'Marc Benioff': '2024-12-22',
  'Farhan Thawar': '2024-12-19',
  'Jackson Shuttleworth': '2024-12-15',
  'Seth Godin': '2024-12-08',
  'Jonathan Lowenhar': '2024-12-05',
  'Michael Margolis': '2024-12-01',
  'Amjad Masad': '2024-11-21',
  'Raaz Herzberg': '2024-11-17',
  'Aman Khan': '2024-11-14',
  'Archie Abrams': '2024-11-07',
  'Alistair Croll': '2024-11-03',
  'Shreyas Doshi': '2024-10-31',
  'Naomi Gleit': '2024-10-27',
  'Jessica Hische': '2024-10-20',
  'Anneka Gupta': '2024-10-17',
  'Tristan de Montebello': '2024-10-13',
  'Raiza Martin': '2024-10-10',
  'John Mark Nickels': '2024-10-06',
  'Alex Komoroske': '2024-10-03',
  'Benjamin Lauzier': '2024-09-29',
  'Tamar Yehoshua': '2024-09-26',
  'Eli Schwartz': '2024-09-19',
  'Camille Fournier': '2024-09-15',
  'Phyl Terry': '2024-09-12',
  'Sean Ellis': '2024-09-05',
  'Vlad Loktev': '2024-09-01',
  'Nikita Bier': '2024-08-25',
  'Deb Liu': '2024-08-22',
  'Kevin Yien': '2024-08-18',
  'Evan LaPointe': '2024-08-11',
  'Joe Hudson': '2024-08-08',
  'Brian Tolkin': '2024-08-04',
  'Timothy Davis': '2024-07-28',
  'Roger Martin': '2024-07-25',
  'Rory Sutherland': '2024-07-21',
  'Jessica Lachs': '2024-07-14',
  'Jeff Weinstein': '2024-07-11',
  'Mike Maples, Jr.': '2024-07-07',
  'Jessica Livingston': '2024-06-27',
  'Ami Vora': '2024-06-23',
  'Tanguy Crusson': '2024-06-16',
  'Jeffrey Pfeffer': '2024-06-13',
  'Cameron Adams': '2024-06-02',
  'Matt Dixon': '2024-05-30',
  'Bangaly Kaba': '2024-05-26',
  'Kenneth Berger': '2024-05-19',
  'Jag Duggal': '2024-05-16',
  'Vikrama Dhiman': '2024-05-12',
  'Hamilton Helmer': '2024-05-05',
  'Annie Duke': '2024-05-02',
  'Kayvon Beykpour': '2024-04-28',
  'Carole Robin': '2024-04-25',
  'Mihika Kapoor': '2024-04-21',
  'Dalton Caldwell': '2024-04-18',
  'David DeSanto': '2024-04-14',
  'Todd Jackson': '2024-04-11',
  'Claire Vo': '2024-04-07',
  'Dharmesh Shah': '2024-04-04',
  'Matt Abrahams': '2024-03-31',
  'Kunal Shah': '2024-03-24',
  'Emilie Gerber': '2024-03-21',
  'Noam Lovinsky': '2024-03-17',
  'Marty Cagan': '2024-03-10',
  'Ray Cao': '2024-03-07',
  'Andrew \'Boz\' Bosworth': '2024-03-03',
  'Donna Lichaw': '2024-02-25',
  'Elizabeth Stone': '2024-02-22',
  'Megan Cook': '2024-02-04',
  'Jonny Miller': '2024-01-28',
  'Geoffrey Moore': '2024-01-25',
  'Richard Rumelt': '2024-01-21',
  'Heidi Helfand': '2024-01-18',
  'Sam Schillace': '2024-01-11',
  'Will Larson': '2024-01-07',
  'Judd Antin': '2024-01-04',
  
  // 2023 Episodes
  'Nir Eyal': '2023-12-29',
  'Sarah Tavel': '2023-12-27',
  'Christian Idiodi': '2023-12-21',
  'Jason Fried': '2023-12-17',
  'Matthew Dicks': '2023-12-15',
  'Kim Scott': '2023-12-10',
  'Anuj Rathi': '2023-12-07',
  'Ebi Atawodi': '2023-12-03',
  'Inbal Shani': '2023-12-01',
  'Tom Conrad': '2023-11-26',
  'Paul Millerd': '2023-11-19',
  'Melissa Perri': '2023-11-16',
  'Denise Tilles': '2023-11-16',
  'Brian Chesky': '2023-11-12',
  'Ramesh Johari': '2023-11-09',
  'Maggie Crowley': '2023-11-05',
  'Bill Carr': '2023-11-02',
  'Eric Ries': '2023-10-29',
  'Paul Adams': '2023-10-26',
  'April Dunford': '2023-10-22',
  'Gina Gotthilf': '2023-10-19',
  'Katie Dill': '2023-10-15',
  'Jason Feifer': '2023-10-12',
  'Karri Saarinen': '2023-10-08',
  'Lane Shackleton': '2023-10-01',
  'Maya Prohovnik': '2023-09-28',
  'Nilan Peiris': '2023-09-24',
  'Itamar Gilad': '2023-09-21',
  'Christopher Lochhead': '2023-09-17',
  'Andy Johns': '2023-09-10',
  'Claire Butler': '2023-09-07',
  'Tim Holley': '2023-09-03',
  'Meltem Kuran Berkowitz': '2023-08-27',
  'Camille Hearst': '2023-08-20',
  'Austin Hay': '2023-08-13',
  'Christopher Miller': '2023-08-10',
  'Geoff Charles': '2023-08-06',
  'Ronny Kohavi': '2023-07-27',
  'Noah Weiss': '2023-07-23',
  'Hari Srinivasan': '2023-07-16',
  'Julia Schottenstein': '2023-07-13',
  'Paige Costello': '2023-07-09',
  'Jiaona Zhang': '2023-07-02',
  'Sri Batchu': '2023-06-25',
  'Melissa Tan': '2023-06-18',
  'Luc Levesque': '2023-06-15',
  'Nikhyl Singhal': '2023-06-11',
  'Jeremy Henrickson': '2023-06-04',
  'Nancy Duarte': '2023-06-01',
  'Andy Raskin': '2023-05-28',
  'Gustav Söderström': '2023-05-21',
  'Scott Belsky': '2023-05-18',
  'Ayo Omojola': '2023-05-14',
  'Jonathan Becker': '2023-05-07',
  'David Singleton': '2023-05-04',
  'Carilu Dietrich': '2023-04-30',
  'Varun Parmar': '2023-04-20',
  'Ada Chen Rekhi': '2023-04-16',
  'Laura Modi': '2023-04-13',
  'Shweta Shrivastava': '2023-04-09',
  'Nikita Miller': '2023-04-06',
  'Hila Qu': '2023-04-02',
  'Casey Winters': '2023-03-30',
  'Lulu Cheng Meservey': '2023-03-23',
  'Josh Miller': '2023-03-19',
  'Christina Wodtke': '2023-03-16',
  'Sriram': '2023-03-12',
  'Aarthi': '2023-03-12',
  'Laura Schaffer': '2023-03-09',
  'Claire Hughes Johnson': '2023-03-05',
  'Gustaf Alströmer': '2023-03-02',
  'Annie Pearl': '2023-02-26',
  'Upasna Gautam': '2023-02-23',
  'Patrick Campbell': '2023-02-19',
  'Christine Itwaru': '2023-02-16',
  'Marily Nika': '2023-02-05',
  'Eeke de Milliano': '2023-02-02',
  'Zoelle Egner': '2023-01-29',
  'Vijay Iyengar': '2023-01-26',
  'Ravi Mehta': '2023-01-19',
  'John Cutler': '2023-01-15',
  'Naomi Ionita': '2023-01-12',
  'Yuhki Yamashita': '2023-01-08',
  'Jules Walter': '2023-01-05',
  
  // 2022 Episodes
  'Chris Hutchins': '2022-12-18',
  'Pete Kazanjy': '2022-12-15',
  'Camille Ricketts': '2022-12-11',
  'Sahil Mansuri': '2022-12-04',
  'Petra Wille': '2022-11-27',
  'Ian McAllister': '2022-11-20',
  'Gergely Orosz': '2022-11-17',
  'Alex Hardiman': '2022-11-13',
  'Matt Mochary': '2022-11-10',
  'Ben Williams': '2022-11-06',
  'Lauren Ipsen': '2022-11-03',
  'Sachin Monga': '2022-10-30',
  'Adam Fishman': '2022-10-13',
  'Dan Hockenmaier': '2022-10-09',
  'Kristen Berman': '2022-10-02',
  'Georgiana Laudi': '2022-09-29',
  'Julian Shapiro': '2022-09-25',
  'Jason Shah': '2022-09-18',
  'Adam Grenier': '2022-09-15',
  'Emily Kramer': '2022-09-11',
  'Ryan J. Salva': '2022-09-04',
  'Yuriy Timen': '2022-09-01',
  'Ken Norton': '2022-07-24',
  'Nickey Skarstad': '2022-07-18',
  'Manik Gupta': '2022-07-14',
  'Merci Grace': '2022-07-11',
  'Sanchan Saxena': '2022-07-05',
  'Teresa Torres': '2022-06-30',
  'Brandon Chu': '2022-06-27',
  'Gibson Biddle': '2022-06-20',
  'Jackie Bavaro': '2022-06-16',
  'Gokul Rajaram': '2022-06-13',
};

/**
 * Get episode date for a guest, or null if not available
 */
export function getGuestEpisodeDate(guestName: string): string | null {
  return guestEpisodeDates[guestName] || null;
}

/**
 * Format episode date for display (e.g., "Dec 28, 2025")
 */
export function formatEpisodeDate(dateStr: string | null): string | null {
  if (!dateStr) return null;
  try {
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  } catch {
    return null;
  }
}

// Episode-specific URL mappings
// Newsletter slugs extracted from https://www.lennyslightninground.com/episodes/
// Spotify and YouTube episode IDs can be added as they become available
export const episodeUrls: Record<string, {
  spotify?: string;  // Episode-specific Spotify URL (e.g., https://open.spotify.com/episode/...)
  youtube?: string;   // Episode-specific YouTube URL (e.g., https://www.youtube.com/watch?v=...)
  newsletter?: string; // Newsletter slug (e.g., 'silicon-valleys-missing-etiquette-playbook')
}> = {
  // 2026 Episodes
  'Sam Lessin': {
    newsletter: 'silicon-valleys-missing-etiquette-playbook',
  },
  'Aishwarya Naresh Reganti': {
    newsletter: 'what-openai-and-google-engineers-learned',
  },
  'Kiriti Badam': {
    newsletter: 'what-openai-and-google-engineers-learned',
  },
  'Molly Graham': {
    newsletter: 'the-high-growth-handbook-molly-graham',
  },
  'Jason Lemkin': {
    newsletter: 'we-replaced-our-sales-team-with-20-ai-agents',
  },
  'Matt MacInnis': {
    newsletter: '10-contrarian-leadership-truths',
  },
  'Sander Schulhoff': {
    newsletter: 'the-coming-ai-security-crisis',
  },
  'Elena Verna': {
    newsletter: 'the-new-ai-growth-playbook-for-2026-elena-verna',
  },
  'Alexander Embiricos': {
    newsletter: 'why-humans-are-ais-biggest-bottleneck',
  },
  'Edwin Chen': {
    newsletter: 'surge-ai-edwin-chen',
  },
  'Tomer Cohen': {
    newsletter: 'why-linkedin-is-replacing-pms',
  },
  'Jeanne Grosser': {
    newsletter: 'what-the-best-gtm-teams-do-differently',
  },
  'Rachel Lockett': {
    newsletter: 'a-guide-to-difficult-conversations',
  },
  'Stewart Butterfield': {
    newsletter: 'slack-founder-stewart-butterfield',
  },
  'Dr. Fei Fei Li': {
    newsletter: 'the-godmother-of-ai',
  },
  'Grant Lee': {
    newsletter: 'how-50-people-built-a-profitable-ai-unicorn',
  },
  'Jen Abel': {
    newsletter: 'the-enterprise-sales-playbook-1m-to-10m-arr',
  },
  'Melanie Perkins': {
    newsletter: 'the-making-of-canva',
  },
  'Dhanji R. Prasanna': {
    newsletter: 'how-block-is-becoming-the-most-ai-native',
  },
  'Chip Huyen': {
    newsletter: 'al-engineering-101-with-chip-huyen',
  },
  'Nicole Forsgren': {
    newsletter: 'how-to-measure-ai-developer-productivity',
  },
  'Dylan Field': {
    newsletter: 'why-ai-makes-design-craft-and-quality-the-new-moat',
  },
  'Robby Stein': {
    newsletter: 'how-google-built-ai-mode-in-under-a-year',
  },
  'Jason Droege': {
    newsletter: 'first-interview-with-scale-ais-ceo-jason-droege',
  },
  'Albert Cheng': {
    newsletter: 'how-to-find-hidden-growth-opportunities-albert-cheng',
  },
  'Nesrine Changuel': {
    newsletter: 'a-4-step-framework-for-building-delightful-products',
  },
  'Hamel Husain': {
    newsletter: 'why-ai-evals-are-the-hottest-new-skill',
  },
  'Shreya Shankar': {
    newsletter: 'why-ai-evals-are-the-hottest-new-skill',
  },
  'Julie Zhuo': {
    newsletter: 'from-managing-people-to-managing-ai-julie-zhuo',
  },
  'Brendan Foody': {
    newsletter: 'experts-writing-ai-evals-brendan-foody',
  },
  'Ethan Smith': {
    newsletter: 'the-ultimate-guide-to-aeo-ethan-smith',
  },
  'Ben Horowitz': {
    newsletter: '46b-of-hard-truths-from-ben-horowitz',
  },
  'Oji Udezue': {
    newsletter: 'how-ai-is-reshaping-the-product-role',
  },
  'Ezinne Udezue': {
    newsletter: 'how-ai-is-reshaping-the-product-role',
  },
  'Howie Liu': {
    newsletter: 'how-we-restructured-airtables-entire-org-for-ai',
  },
  'Asha Sharma': {
    newsletter: 'how-80000-companies-build-with-ai-asha-sharma',
  },
  'Garrett Lord': {
    newsletter: 'inside-handshake-garrett-lord',
  },
  'Eoghan McCabe': {
    newsletter: 'how-intercom-rose-from-the-ashes-eoghan-mccabe',
  },
  'Brian Balfour': {
    newsletter: 'why-chatgpt-will-be-the-next-big-growth-channel-brian-balfour',
  },
  'Matt LeMay': {
    newsletter: 'the-one-question-that-saves-product-careers-matt-lemay',
  },
  'Nick Turley': {
    newsletter: 'inside-chatgpt-nick-turley',
  },
  'Chip Conley': {
    newsletter: 'chip-conley',
  },
  'Bret Taylor': {
    newsletter: 'he-saved-openai-bret-taylor',
  },
  // Add more mappings as needed - this is a sample of recent episodes
  // The structure supports adding spotify and youtube episode IDs when available
};

/**
 * Generate podcast episode links for a specific guest
 * Returns Spotify, YouTube, and Newsletter links (episode-specific when available)
 */
export function getEpisodeLinks(guestName: string): {
  spotify?: string;
  youtube?: string;
  newsletter?: string;
} {
  const links: { spotify?: string; youtube?: string; newsletter?: string } = {};
  
  // Get episode-specific URLs if available
  const episodeData = episodeUrls[guestName];
  
  if (episodeData) {
    // Use episode-specific Spotify link if available
    if (episodeData.spotify) {
      links.spotify = episodeData.spotify;
    } else {
      // Fallback to show page
      links.spotify = `https://open.spotify.com/show/2dR1MUZEHCOnz1LVfNac0j`;
    }
    
    // Use episode-specific YouTube link if available
    if (episodeData.youtube) {
      links.youtube = episodeData.youtube;
    } else {
      // Fallback to channel
      links.youtube = `https://www.youtube.com/@lennyspodcast`;
    }
    
    // Use episode-specific newsletter link
    if (episodeData.newsletter) {
      links.newsletter = `https://www.lennysnewsletter.com/p/${episodeData.newsletter}`;
    } else {
      // Fallback to archive
      links.newsletter = `https://www.lennysnewsletter.com/podcast/archive`;
    }
  } else {
    // No episode-specific data - use fallback links
    links.spotify = `https://open.spotify.com/show/2dR1MUZEHCOnz1LVfNac0j`;
    links.youtube = `https://www.youtube.com/@lennyspodcast`;
    links.newsletter = `https://www.lennysnewsletter.com/podcast/archive`;
  }
  
  return links;
}

/**
 * Compare two guests by episode date (latest first)
 * Returns negative if a is more recent, positive if b is more recent, 0 if equal
 */
export function compareGuestsByDate(guestA: string, guestB: string): number {
  const dateA = getGuestEpisodeDate(guestA);
  const dateB = getGuestEpisodeDate(guestB);
  
  // Both have dates - compare directly
  if (dateA && dateB) {
    return dateB.localeCompare(dateA); // Reverse order (latest first)
  }
  
  // Only A has date - A comes first
  if (dateA && !dateB) {
    return -1;
  }
  
  // Only B has date - B comes first
  if (!dateA && dateB) {
    return 1;
  }
  
  // Neither has date - maintain original order (or alphabetical)
  return 0;
}
